const Cryptlib = require('cryptlib');
const WEB_APP_ENCRYPT_KEY = window._env_.AppEncryptKey;


/**
 * Encrypt the json object and store into localstorage
 * @param {string} key Localstorage Key
 * @param {object} data Localstorage data - json object
 */
export function encryptAndStoreInLocalStorage(key, data) {
    let ecytData = encrypt(JSON.stringify(data), key);
    let encryptedKey = encrypt(key, WEB_APP_ENCRYPT_KEY);
   
    localStorage.setItem(encryptedKey, ecytData);
    return true;
}

/**
 * Decrypt the json object and retive data from localstorage
 * @param {string} key Localstorage Key
 */
export function getFromLocalStorageAndDecrypt(key) {
    let encryptedKey = encrypt(key, WEB_APP_ENCRYPT_KEY);

    let lsData = localStorage.getItem(encryptedKey);
    try {
        let dcypData = decrypt(lsData, key);
        return JSON.parse(dcypData);
    } catch (error){
        return lsData;
    }    
}


export function deleteItemFromLocalStorage(key) {
    let encryptedKey = encrypt(key, WEB_APP_ENCRYPT_KEY);
    localStorage.removeItem(encryptedKey);
}

export function checkExistingKeyAvailable(key) {
    if(localStorage.hasOwnProperty(key)){
        localStorage.removeItem(key);

    }

    let defaultStorageArr = ['DefaultMsgCharLimit','DefaultPagerMaxLength','DefaultPagerMinLength','sessionStartTime','totalSessionTime']
    
    defaultStorageArr.forEach(element => {
        if(localStorage.hasOwnProperty(element)){
            localStorage.removeItem(element);
    
        }
    });
   
}

const encrypt = (data, key) => {
    const encryptKey = Cryptlib.getHashSha256(key, 32);
    return Cryptlib.encrypt(encodeURIComponent(data), encryptKey, WEB_APP_ENCRYPT_KEY);
};
  
const decrypt = (data, key) => {
    const decryptKey = Cryptlib.getHashSha256(key, 32);
    return decodeURIComponent(Cryptlib.decrypt(data, decryptKey, WEB_APP_ENCRYPT_KEY));
};
